import React, { useState, useEffect, useCallback } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './App.css';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import EnergyGraph from './components/EnergyGraph';
import SummaryPanel from './components/SummaryPanel';
import WeatherPanel from './components/WeatherPanel';
import SettingsPage from './pages/SettingsPage'; // NEW: Import SettingsPage

function App() {

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [targetDate, setTargetDate] = useState(null);

  const [activeEmsView, setActiveEmsView] = useState('ems-dashboard'); // NEW: For menu selection

  

  const [dashboardData, setDashboardData] = useState(null);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);

  const [helloMessage, setHelloMessage] = useState('');

  const [showWeatherPanel, setShowWeatherPanel] = useState(true);



  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);



  const fetchHello = useCallback(async () => {

    // ... (fetchHello implementation remains the same)

  }, []);



  useEffect(() => {

    if (activeEmsView !== 'ems-dashboard') { // Skip data fetch if not on dashboard

      setDashboardData(null); // Clear data when switching away

      setLoading(false);

      setError(null);

      return;

    }



    const fetchData = async () => {

      setLoading(true);

      setError(null);

      

      try {

        const requestBody = targetDate 

          ? { targetDate: targetDate.toISOString().split('T')[0] }

          : {};



        const response = await fetch('/v1/ems-latest-prediction', {

          method: 'POST',

          headers: { 

            'Content-Type': 'application/json',

            'x-api-key': process.env.REACT_APP_DASHBOARD_API_KEY 

          },

          body: JSON.stringify(requestBody)

        });



        if (!response.ok) {

          if (response.status === 404) {

            setError(new Error(`指定された日付のデータが見つかりませんでした。`));

            setDashboardData(null);

          } else {

            throw new Error(`HTTP error! status: ${response.status}`);

          } }

        else {

          const data = await response.json();

          setDashboardData(data);

        }

      } catch (e) {

        setError(e);

      } finally {

        setLoading(false);

      }

    };



    fetchData();

  }, [targetDate, activeEmsView]); // Depend on activeEmsView as well



  const menuItems = [

    { id: 'ems-dashboard', label: 'EMSダッシュボード' },

    { id: 'ems-settings', label: '設定' }, // NEW: Settings menu item

  ];



  const handleMenuChange = (menuId) => {

    setActiveEmsView(menuId); // Set active view based on menu selection

    setIsSidebarOpen(false); // Close sidebar on menu selection

    if (menuId === 'ems-dashboard') { // If returning to dashboard, reset targetDate

        setTargetDate(null);

    }

  };



  const renderContent = () => {

    if (loading) {

      return (

        <div className="loading-overlay">

          <div className="loading-spinner"></div>

          <p className="loading-text">Loading...</p>

        </div>

      );

    }

    if (error && !dashboardData) { 

        return <div className="error-message">データが取得できませんでした。</div>;

    }



    const dataForView = dashboardData;

    const hasError = !!error;



    if (!dataForView && activeEmsView === 'ems-dashboard') return <div className="loading-message">データがありません。</div>;



    if (activeEmsView === 'ems-settings') {

      return <SettingsPage onCancel={() => setActiveEmsView('ems-dashboard')} />;

    } else if (activeEmsView === 'ems-dashboard') {

      return (

        <div className="center-content">

          <SummaryPanel data={dataForView} />

          

          <div className="main-display-area">

            {hasError && (

              <div className="error-overlay">

                <p className="error-overlay-text">データが取得できませんでした。</p>

              </div>

            )}

            <EnergyGraph 

              data={dataForView}

              targetDate={targetDate}

              onDateChange={setTargetDate}

              onViewModeChange={(mode) => setShowWeatherPanel(mode === 'graph')}

            />

            {showWeatherPanel && <WeatherPanel data={dataForView} />}

          </div>

        </div>

      );

    }

    return null; // Should not happen

  }



  return (

    <div className="app">

      <Header onMenuClick={toggleSidebar} />

      <div className="main-content">

        <Sidebar 

          isOpen={isSidebarOpen}

          menuItems={menuItems} 

          activeMenu={activeEmsView} 

          onMenuChange={handleMenuChange} 

        />

        {isSidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}

        <main className="app-main">

          {/* Toolbar is now moved inside EnergyGraph */}

          <div className="content-area">

            {renderContent()}

          </div>

        </main>

      </div>

      <footer className="app-footer">

        <button onClick={fetchHello} style={{marginRight: '20px'}}>Test API</button>

        <span>API Status: {helloMessage}</span>

      </footer>

    </div>

  );

}



export default App;